<style>
#payslip_table tbody tr,
#payslip_table tbody td {
	padding: 2px !important;
}

#payslip_table table,
#payslip_table tr,
#payslip_table td,
#payslip_table th {
	min-width: none !important;
	width: fit-content;
}
</style>
<template>
	<div class="card card-stats card-raised pb-4">
		<div class="d-flex justify-content-center align-items-center flex-column rounded bg-light mx-auto">

			<div v-if="!editDailog" class="card-body card-raised" style="max-width: 450px">
				<span class="d-none d-md-block float-right ">
					<el-button class="d-flex flex-row align-items-center justify-content-center" type="text"
						@click="shareOnWhatsApp"><i style="color:rgb(2, 156, 2);font-size:x-large"
							class="fa fa-whatsapp"></i><span class="align-middle h-100" style="color: black;">
							SHARE</span></el-button></span>

				<span class=" d-block float-left text-center">
					<el-button type="text" @click="downloadImageAndShare"><i style="color:gray;font-size:x-large"
							class="fa fa-download"></i> <span style="color: black;">Download And
							Copy</span></el-button></span>

				<span class="d-block float-right  ">
					<el-button class="d-flex flex-row align-items-center justify-content-center" type="text"
						@click="editDailog = true"><i style="color:#2CA8FF;font-size:x-large" class="fa fa-edit"></i><span
							class="align-middle h-100" style="color: black;">
							EDIT</span></el-button></span>

				<div class="my-4 pt-2">
					<div id="HtmlContent" class="p-2 bg-light">
						<div class="bg-white py-4" style="caption-side: top; text-align: center">
							<div class="text-uppercase font-weight-bold text-dark">
								<img style="width: 80px;" src="../../../../public/img/AtomX-orange2.png" alt="atomXlogo" />
							</div>
							<div class="text-uppercase  font-weight-bold text-dark">
								Pay Slip
							</div>
							<div>
								{{ details.info.event.name ?? '' }} ({{ details.info.event.id ?? '' }}), <span class="text-capitalize">{{
                  details.info.event.locationCity ?? this.event.locationCity }}</span>,
								<span class="text-nowrap" style="
										/* color: #6c757d; */
										margin: 0px;

										font-size: 14px;
										overflow: hidden;
										text-align: center !important;
										font-family: 'Montserrat',

											'Helvetica Neue', Arial, sans-serif;
									">
									{{
										details.info.minTxnAt.split("T")[0] !==
										details.info.maxTxnAt.split("T")[0]
										? "\n" +
										getFormattedDate(details.info.minTxnAt)
										+
										" to " +
										getFormattedDate(details.info.maxTxnAt)
										: getFormattedDate(details.info.minTxnAt)
									}}
								</span>
							</div>
						</div>
						<table id="payslip_table" class="text-uppercase table table-bordered bg-white m-4"
							style="border-spacing: 1px 2px; padding-bottom: 400px !important;">



							<tbody class="table-group-divider border-top-0">
								<tr class="table-secondary">
									<th scope="col" class="table-secondary font-weight-bold">
										SUMMARY
									</th>
									<th scope="col" class="table-secondary font-weight-bold text-center">
										AMOUNT
									</th>
								</tr>
							</tbody>
							<tbody class="border-top-0">
								<tr v-for="type in Object.keys(details.summary)" :key="type">
									<td v-if="typeof details.summary[type] !==
										'undefined' && ((type == 'activations') ? parseInt(details.summary[type].amount) != 0 : true)
										">
										{{
											type == "devices" || type == "days" || type == "pos_sales" || type == "breakage" ||
											type
											== "paid_breakage"
											? ""
											: "CASHLESS"
										}}
										{{ type == "pos_sales" ? "POS Sales" :
											type.split('_')
												.map(word => word.toUpperCase())
												.join(' ')
										}}
										<p class="mb-0" style="font-size: 12px; color:gray" v-if="type == 'breakage'">
											(TOPUPS -
											SALE - ACTIVATIONS)
										</p>
										<p class="mb-0" style="font-size: 12px; color:gray" v-if="type == 'paid_breakage'">
											AFTER COMPS REMOVAL</p>
									</td>
									<td class="text-right "
										v-if="(type == 'activations') ? parseInt(details.summary[type].amount) != 0 : true">
										{{
											type == "devices" || type == "days"
											? details.summary[type].count
											: type == "paid_breakage" || type == "breakage" ?
												parseInt(details.summary[type]).toLocaleString("en-IN") :
												parseInt(details.summary[type].amount).toLocaleString("en-IN")
										}}</td>
								</tr>
							</tbody>
							<tbody class="border-top-0">
								<tr>
									<td class="table-secondary font-weight-bold" colspan="2">
										AMOUNT WITH ATOMX
									</td>
								</tr>
							</tbody>
							<tbody class="border-top-0" v-if="moniesHas('cashless')">
								<tr v-for="type in Object.keys(details.monies.cashless)" :key="type">
									<td v-if="typeof details.monies.cashless[type] !==
										'undefined'
										">
										<span
											:class="(details.monies.cashless[type].handover) ? 'aml-text-gray ' : 'text-right'">{{
												type.charAt(0).toUpperCase() +
												type.slice(1)
											}} {{
	details.monies.cashless[type].handover
	? "( Handover )"
	: ""
}}</span>
										<pre class="mb-0"
											style="font-family: 'Montserrat', 'Helvetica Neue', Arial, sans-serif; font-size: 12px; color:gray"
											v-if="details.monies.cashless[type].desc">{{
												details.monies.cashless[type].desc }}</pre>
									</td>
									<td
										:class="(details.monies.cashless[type].handover) ? 'aml-text-gray text-right' : 'text-right'">
										{{
											parseInt(details.monies.cashless[type].amount).toLocaleString("en-IN") }}</td>
								</tr>
							</tbody>
							<tbody class="border-top-0" v-if="moniesHas('pos')">
								<tr v-for="type in Object.keys(details.monies.pos)" :key="type">
									<td v-if="typeof details.monies.pos[type] !==
										'undefined'
										">
										<span
											:class="(details.monies.pos[type].handover) ? 'aml-text-gray text-right' : 'text-right'">
											POS {{
												type.charAt(0).toUpperCase() +
												type.slice(1)
											}} {{
	details.monies.pos[type].handover
	? "( Handover )"
	: ""
}}</span>
										<pre class="mb-0"
											style="font-family: 'Montserrat', 'Helvetica Neue', Arial, sans-serif; font-size: 12px; color:gray"
											v-if="details.monies.pos[type].desc">{{
												details.monies.pos[type].desc }}</pre>
									</td>
									<td
										:class="(details.monies.pos[type].handover) ? 'aml-text-gray text-right' : 'text-right'">
										{{
											parseInt(details.monies.pos[type].amount).toLocaleString("en-IN") }}</td>
								</tr>
							</tbody>
							<tbody class="border-top-0">
								<tr>
									<td>Sub-Total
									</td>
									<td class="text-right">{{ details.monies.moniesSubTotal.toLocaleString('en-IN', {
										currency: 'INR',
										minimumFractionDigits: 2,
										maximumFractionDigits: 2
									}).endsWith('.00') ? details.monies.moniesSubTotal.toLocaleString('en-IN', {
										currency: 'INR',
										minimumFractionDigits: 2,
										maximumFractionDigits: 2
									}).replace('.00', '') : details.monies.moniesSubTotal.toLocaleString('en-IN', {
										currency: 'INR',
										minimumFractionDigits: 2,
										maximumFractionDigits: 2
									}) }}</td>
								</tr>
							</tbody>
							<tbody class="border-top-0" v-if="moniesHas('mdr')">
								<tr>
									<td v-if="typeof details.monies.mdr !==
										'undefined'
										" style="font-size:12px">
										MDR Bank Deductions
									</td>
									<td class="text-right">{{ parseFloat(details.monies.mdr.amount).toLocaleString('en-IN',
										{
											currency: 'INR',
											minimumFractionDigits: 2,
											maximumFractionDigits: 2
										}).endsWith('.00') ? parseFloat(details.monies.mdr.amount).toLocaleString('en-IN', {
											currency: 'INR',
											minimumFractionDigits: 2,
											maximumFractionDigits: 2
										}).replace('.00', '') :
										parseFloat(details.monies.mdr.amount).toLocaleString('en-IN', {
											currency: 'INR',
											minimumFractionDigits: 2,
											maximumFractionDigits: 2
										}) }}
									</td>
								</tr>
							</tbody>


							<tbody class="border-top-0">
								<tr style="font-weight: 700;">
									<td>Total
									</td>
									<td class="text-right">{{ details.monies.moniesTotal.toLocaleString('en-IN', {
										currency: 'INR',
										minimumFractionDigits: 2,
										maximumFractionDigits: 2
									}).endsWith('.00') ? details.monies.moniesTotal.toLocaleString('en-IN', {
										currency: 'INR',
										minimumFractionDigits: 2,
										maximumFractionDigits: 2
									}).replace('.00', '') : details.monies.moniesTotal.toLocaleString('en-IN', {
										currency: 'INR',
										minimumFractionDigits: 2,
										maximumFractionDigits: 2
									}) }}</td>
								</tr>
							</tbody>
							<tbody class="border-top-0" v-if="parseFloat(details.invoiceTotal) > 0">
								<tr>
									<td class="table-secondary font-weight-bold" colspan="2">
										INVOICE
									</td>
								</tr>
							</tbody>
							<tbody class="border-top-0">
								<tr v-for="type in Object.keys(details.invoice)" :key="type">
									<td v-if="typeof details.invoice[type] !==
										'undefined'
										">
										<span class="text-uppercase">
											{{
												type.replace(/([a-z])([A-Z])/g, '$1 $2')
											}} </span><span v-if="parseInt(details.invoice[type].count) > 1 &&
		parseFloat(details.invoice[type].rate) > 0" style="font-size: 12px; color:gray"> ( {{
			details.invoice[type].count.toLocaleString("en-IN") }} @ {{
		details.invoice[type].rate.toLocaleString("en-IN") }} )</span>
										<pre class="mb-0"
											style="font-family: 'Montserrat', 'Helvetica Neue', Arial, sans-serif; font-size: 12px; color:gray"
											v-if="details.invoice[type].desc">{{
												details.invoice[type].desc }}</pre>
									</td>
									<td class="text-right ">{{
										parseFloat(details.invoice[type].amount).toLocaleString('en-IN') }}
									</td>
								</tr>
							</tbody>
							<tbody class="border-top-0" v-if="parseFloat(details.invoiceSubTotal) > 0">
								<tr style="font-weight: 700;">
									<td>Sub-Total
									</td>
									<td class="text-right ">
										{{ details.invoiceSubTotal.toLocaleString('en-IN', {
											currency: 'INR',
											minimumFractionDigits: 2,
											maximumFractionDigits: 2
										}).endsWith('.00') ? details.invoiceSubTotal.toLocaleString('en-IN', {
											currency: 'INR',
											minimumFractionDigits: 2,
											maximumFractionDigits: 2
										}).replace('.00', '') : details.invoiceSubTotal.toLocaleString('en-IN', {
											currency: 'INR',
											minimumFractionDigits: 2,
											maximumFractionDigits: 2
										}) }}
									</td>
								</tr>
							</tbody>
							<tbody class="border-top-0" v-if="parseFloat(details.invoiceTotalGST) > 0">
								<tr>
									<td>GST
									</td>
									<td class="text-right ">{{ details.invoiceTotalGST.toLocaleString('en-IN', {
										currency: 'INR',
										minimumFractionDigits: 2,
										maximumFractionDigits: 2
									}).endsWith('.00') ? details.invoiceTotalGST.toLocaleString('en-IN', {
										currency: 'INR',
										minimumFractionDigits: 2,
										maximumFractionDigits: 2
									}).replace('.00', '') : details.invoiceTotalGST.toLocaleString('en-IN', {
										currency: 'INR',
										minimumFractionDigits: 2,
										maximumFractionDigits: 2
									}) }}</td>
								</tr>
							</tbody>
							<tbody class="border-top-0" v-if="parseFloat(details.invoiceTotal) > 0">
								<tr>
									<td>Total
									</td>
									<td class="text-right ">{{ parseFloat(details.invoiceTotal).toLocaleString('en-IN', {
										currency: 'INR',
										minimumFractionDigits: 2,
										maximumFractionDigits: 2
									}).endsWith('.00') ? parseFloat(details.invoiceTotal).toLocaleString('en-IN', {
										currency: 'INR',
										minimumFractionDigits: 2,
										maximumFractionDigits: 2
									}).replace('.00', '') : parseFloat(details.invoiceTotal).toLocaleString('en-IN', {
										currency: 'INR',
										minimumFractionDigits: 2,
										maximumFractionDigits: 2
									}) }}</td>
								</tr>
							</tbody>
							<tbody v-if="dat.tds.isActive" class="border-top-0">
								<tr>
									<td>TDS
									</td>
									<td class="text-right ">{{ details.tds.amount.toLocaleString('en-IN', {
										currency: 'INR',
										minimumFractionDigits: 2,
										maximumFractionDigits: 2
									}).endsWith('.00') ? details.tds.amount.toLocaleString('en-IN', {
										currency: 'INR',
										minimumFractionDigits: 2,
										maximumFractionDigits: 2
									}).replace('.00', '') : details.tds.amount.toLocaleString('en-IN', {
										currency: 'INR',
										minimumFractionDigits: 2,
										maximumFractionDigits: 2
									}) }}</td>
								</tr>
							</tbody>

							<tbody class="border-top-0" v-if="Object.keys(details.extraCharges).length > 0">
								<tr>
									<td class="table-secondary font-weight-bold" colspan="2">
										Extra Charges
									</td>
								</tr>
							</tbody>
							<tbody class="border-top-0" v-if="Object.keys(details.extraCharges).length > 0">
								<tr v-for="type in Object.keys(details.extraCharges)" :key="type">
									<td v-if="typeof details.extraCharges[type] !==
										'undefined'
										">
										<span class="text-capitalize">
											{{
												type.toUpperCase()
											}}</span>
										<p class="mb-0" style="font-size: 12px; color:gray"
											v-if="details.extraCharges[type].desc">{{
												details.extraCharges[type].desc }}</p>
									</td>
									<td class="text-right">
										{{
											parseFloat(details.extraCharges[type].amount).toLocaleString("en-IN") }}</td>
								</tr>
							</tbody>
							<tbody class="border-top-0" v-if="Object.keys(details.extraCharges).length > 1">
								<tr>
									<td>Total
									</td>
									<td class="text-right ">
										{{ parseFloat(details.extraChargesTotal).toLocaleString('en-IN', {
											currency: 'INR',
											minimumFractionDigits: 2,
											maximumFractionDigits: 2
										}).endsWith('.00') ? parseFloat(details.extraChargesTotal).toLocaleString('en-IN', {
											currency: 'INR',
											minimumFractionDigits: 2,
											maximumFractionDigits: 2
										}).replace('.00', '') :
											parseFloat(details.extraChargesTotal).toLocaleString('en-IN', {
												currency: 'INR',
												minimumFractionDigits: 2,
												maximumFractionDigits: 2
											}) }}
									</td>
								</tr>
							</tbody>
							<tbody class="table-secondary font-weight-bold border-top-0">
								<tr>
									<td>{{ details.payable >= 0 ? "Payable" : "Receivable" }} </td>
									<td class="text-right">{{ details.payable.toLocaleString('en-IN', {
										currency: 'INR',
										minimumFractionDigits: 2,
										maximumFractionDigits: 2
									}).endsWith('.00') ? Math.abs(details.payable).toLocaleString('en-IN', {
										currency: 'INR',
										minimumFractionDigits: 2,
										maximumFractionDigits: 2
									}).replace('.00', '') : Math.abs(details.payable).toLocaleString('en-IN', {
										currency: 'INR',
										minimumFractionDigits: 2,
										maximumFractionDigits: 2
									}) }}</td>
								</tr>
							</tbody>
						</table>
						<div style="font-size: xx-small;" class="mt-4 text-center text-uppercase text-sm text-dark">
							System-Generated: Confidential. For intended recipient only. Do not share without written
							consent
						</div>
					</div>
					<img id="img1" :src="imageUrl" class="d-none" />
				</div>

			</div>
		</div>
		<span v-if="editDailog" class="p-2">

			<!-- <el-dialog class="el-dialog-fullwidth" style="margin-top:1vh !important;"
				:title="'Edit DATA LOG FOR ' + event.name" v-model="editDailog"> -->
			<span class="mt-3 d-block">
				<el-form>
					<div class="">
						<!--LOADER-->
						<div class="position-relative h-100 w-100 bg-light" style="z-index: 1029" v-if="isLoading.update">
							<div class="custom-loading text-center position-relative" style="top: 30%">
								<svg class="circular" viewBox="-10, -10, 50, 50">
									<path class="path" d="
											M 30 15
											L 28 17
											M 25.61 25.61
											A 15 15, 0, 0, 1, 15 30
											A 15 15, 0, 1, 1, 27.99 7.5
											L 15 15
										  " style="stroke-width: 1px; fill: rgba(0, 0, 0, 0)" />
								</svg>
							</div>
						</div>

						<!-- Data -->
						<div class="bg-light p-2" v-if="Object.keys(dat).length > 0 && !isLoading.update">
							<el-divider class=""><i class="" />DATA</el-divider>

							<div class="table-responsive text-responsive">
								<table class="m-0 table-bordered table-hover">
									<tbody class="table-group-divider border-top-0">
										<tr class="table-secondary">
											<th scope="col" class="table-secondary font-weight-bold">
												TRANSACTIONS
											</th>
											<th scope="col" class="table-secondary font-weight-bold text-center"
												colspan="3">
												COUNT
											</th>
											<th scope="col" class="table-secondary font-weight-bold text-center"
												colspan="1">
												AMOUNT
											</th>
										</tr>

										<tr class="align-items-center" v-for="type in Object.keys(dat.summary).filter(
											(t) => t !== 'days' && t !== 'devices'
										)">
											<td class="" v-if="typeof dat.summary[type].count !== 'undefined'">
												<i class="fas fa-times-circle cursor-pointer"
													@click="removeItem('summary', type)" />

												<span class="pl-2 pr-sm-4 pr-2">{{ dat.summary[type].info
												}}</span>
												<i class="fas fa-plus-circle cursor-pointer my-auto"
													@click="addActivationShare(dat.summary[type].count)" v-if="type === 'activations' &&
														!dat.summary.activation_share
														" />
											</td>
											<td></td>
											<td class="" v-if="typeof dat.summary[type].count !== 'undefined'">
												<input style="border: none; width: 100%" type="number" placeholder="Count"
													v-model="dat.summary[type].count" />
											</td>
											<td></td>
											<td class="" v-if="typeof dat.summary[type].amount !== 'undefined'">
												<input type="number" style="border: none; width: 100%" placeholder="Amount"
													v-model="dat.summary[type].amount" />
											</td>
										</tr>
										<tr v-if="this.dat.summary.topups">
											<td class="">BREAKAGE</td>
											<td colspan="3"></td>
											<td class="">
												<input type="number" style="border: none; width: 100%" placeholder="Amount"
													v-model="dat.summary.breakage" />
											</td>
										</tr>
										<tr v-if="this.dat.summary.topup_comps ||
											this.dat.summary.sale_comps
											">
											<td class="">PAID BREAKAGE
											</td>
											<td colspan="3">
											</td>
											<td class="">
												<input type="number" style="border: none; width: 100%" placeholder="Amount"
													v-model="dat.summary.paid_breakage" />
											</td>
										</tr>
										<tr class="" v-for="type in ['devices', 'days']">
											<td class="" v-if="typeof dat.summary[type].count !== 'undefined'">
												<i class="fas fa-times-circle cursor-pointer"
													@click="removeItem('summary', type)" />

												<span class="pl-2 pr-sm-4 pr-2">{{ dat.summary[type].info
												}}</span>
												<i class="fas fa-plus-circle cursor-pointer my-auto"
													@click="addActivationShare(dat.summary[type].count)" v-if="type === 'activations' &&
														!dat.summary.activation_share
														" />
											</td>
											<td></td>
											<td class="" colspan="1" v-if="typeof dat.summary[type].count !== 'undefined'">
												<input style="border: none; width: 100%" type="number" placeholder="Count"
													v-model="dat.summary[type].count" />
											</td>
											<td colspan="2"></td>
										</tr>
									</tbody>
									<tbody class="border-top-0">
										<tr class="">
											<td class="table-secondary font-weight-bold">
												AMOUNT WITH ATOMX
												<el-button icon="fas fa-money-bill-wave" class="aml-bg-teal-3 border-0"
													type="primary" size="small" circle v-if="dat.monies.cashless.CARD"
													@click="dat.monies.cashless.CASH_PENDING = {
														amount: 0,
														count: 0,
													}" />
												<el-button icon="fas fa-plus" class="aml-bg-teal-3 border-0" type="primary"
													size="small" circle @click="addItem('monies', 'cashless')" />
											</td>
											<td class="table-secondary font-weight-bold text-center" colspan="3">
												COUNT
											</td>
											<td class="table-secondary font-weight-bold">AMOUNT</td>
										</tr>
									</tbody>
									<tbody class="" style="width: 100%" v-if="typeof dat.monies.cashless !== 'undefined'">
										<tr class="" v-for="type in Object.keys(dat.monies.cashless)">
											<td class="">
												<i class="fas fa-times-circle cursor-pointer"
													@click="removeItem('monies', 'cashless', type)" />
												<span v-if="!dat.monies.cashless[type].isNew" class="pl-2 pr-sm-4 pr-2">{{
													type
												}}</span>
												<input v-if="dat.monies.cashless[type].isNew"
													style="border: none; background-color: transparent" placeholder="NOTE"
													v-model="dat.monies.cashless[type].name" @change="checkItemName('monies',
														'cashless',
														type)" />
												<i class="fas fa-info-circle cursor-pointer"
													@click="openInfoBox(dat.monies.cashless[type])" />
												<el-input v-if="dat.monies.cashless[type].isDescOpen"
													v-model="dat.monies.cashless[type].desc" :rows="2" type="textarea"
													placeholder="Please input"
													@focusout="openInfoBox(dat.monies.cashless[type])" />
											</td>

											<td class="">
												<el-switch v-model="dat.monies.cashless[type].handover"
													active-color="#13ce66" inactive-color="#ccc" :active-value="true"
													:inactive-value="false" class="d-inline" active-text="HandOver"
													@change="updateMoniesTotal()" />
											</td>
											<td class="">
												<input style="border: none; width: 100%" type="number" placeholder="Count"
													v-model="dat.monies.cashless[type].count" />
											</td>
											<td></td>
											<td class="">
												<input style="border: none; width: 100%" type="number" placeholder="Amount"
													v-model="dat.monies.cashless[type].amount"
													@change="updateMoniesTotal()" />
											</td>
										</tr>
									</tbody>
									<tbody class="" style="width: 100%" v-if="typeof dat.monies.pos !== 'undefined'">
										<tr class="col-12 col-md-6" v-for="type in Object.keys(dat.monies.pos)">
											<td class="">
												<i class="fas fa-times-circle cursor-pointer"
													@click="removeItem('monies', 'cashless', type)" />
												<span v-if="!dat.monies.pos[type].isNew" class="pl-2 pr-sm-4 pr-2">POS
													{{
														type
													}}</span>
												<input v-if="dat.monies.pos[type].isNew"
													style="border: none; background-color: transparent" placeholder="NOTE"
													v-model="dat.monies.pos[type].name" @change="checkItemName('monies',
														'cashless',
														type)" />
												<i class="fas fa-info-circle cursor-pointer"
													@click="openInfoBox(dat.monies.pos[type])" />
												<el-input v-if="dat.monies.pos[type].isDescOpen"
													v-model="dat.monies.pos[type].desc" :rows="2" type="textarea"
													placeholder="Please input"
													@focusout="openInfoBox(dat.monies.pos[type])" />
											</td>
											<td class="">
												<el-switch v-model="dat.monies.pos[type].handover" active-color="#13ce66"
													inactive-color="#ccc" :active-value="true" :inactive-value="false"
													class="d-inline" active-text="HandOver" @change="updateMoniesTotal()" />
											</td>
											<td class=""><input style="border: none; width: 100%" type="number"
													placeholder="Count" v-model="dat.monies.pos[type].count" />
											</td>
											<td></td>
											<td class="" colspan="1">
												<input style="border: none; width: 100%" type="number" placeholder="Amount"
													v-model="dat.monies.pos[type].amount" @change="updateMoniesTotal()" />
											</td>
										</tr>
									</tbody>
									<tbody class="" style="width: 100%">
										<tr class=" font-weight-bold">
											<td class=""></td>
											<td class=""></td>
											<td class=""></td>
											<td class="">Sub Total</td>

											<td class="">
												{{ parseFloat(getMoniesSubTotal()).toLocaleString('en-IN', {
													currency: 'INR',
													minimumFractionDigits: 2,
													maximumFractionDigits: 2
												}).endsWith('.00') ?
													parseFloat(getMoniesSubTotal()).toLocaleString('en-IN', {
														currency: 'INR',
														minimumFractionDigits: 2,
														maximumFractionDigits: 2
													}).replace('.00', '') :
													parseFloat(getMoniesSubTotal()).toLocaleString('en-IN', {
														currency: 'INR',
														minimumFractionDigits: 2,
														maximumFractionDigits: 2
													}) }}
											</td>
										</tr>
									</tbody>
									<tbody class="" style="width: 100%">
										<tr class="">
											<td class="">MDR Bank Deductions</td>
											<td class="">
												CardAmount<input style="border: none; width: 100%" type="number"
													@change="updateAmount2()" placeholder="cardAmount"
													v-model="dat.monies.mdr.cardAmount" />
											</td>
											<td class="">
												Rate<input style="border: none; width: 100%" type="number"
													@change="updateAmount2()" placeholder="rate"
													v-model="dat.monies.mdr.rate" />
											</td>
											<td class="">
												GST<input style="border: none; width: 100%" placeholder="GST(%)"
													v-model="dat.monies.mdr.gst" @change="updateAmount2()" />
											</td>
											<td class="">
												<input style="border: none; width: 100%" placeholder="Amount" disabled
													v-model="dat.monies.mdr.amount" @change="updateMoniesTotal()" />
											</td>
										</tr>
									</tbody>

									<tbody class="" style="width: 100%">
										<tr class=" font-weight-bold">
											<td class=""></td>
											<td class=""></td>
											<td class=""></td>
											<td class="">Total</td>

											<td class="">
												{{ parseFloat(getMoniesTotal()).toLocaleString('en-IN', {
													currency: 'INR',
													minimumFractionDigits: 2,
													maximumFractionDigits: 2
												}).endsWith('.00') ?
													parseFloat(getMoniesTotal()).toLocaleString('en-IN', {
														currency: 'INR',
														minimumFractionDigits: 2,
														maximumFractionDigits: 2
													}).replace('.00', '') :
													parseFloat(getMoniesTotal()).toLocaleString('en-IN', {
														currency: 'INR',
														minimumFractionDigits: 2,
														maximumFractionDigits: 2
													}) }}
												<!-- {{ dat.monies.moniesTotal.toLocaleString('en-IN') }} -->
											</td>
										</tr>
									</tbody>
									<tbody class="border-top-0">
										<tr class="">
											<td class="table-secondary font-weight-bold">
												INVOICE
												<el-button icon="fas fa-plus" class="aml-bg-teal-3 border-0" type="primary"
													size="small" circle @click="addItem('invoice', 'cashless')" />
											</td>
											<td class="table-secondary font-weight-bold">COUNT</td>
											<td class="table-secondary font-weight-bold">RATE</td>
											<td class="table-secondary font-weight-bold">GST</td>
											<td class="table-secondary font-weight-bold">AMOUNT</td>
										</tr>
									</tbody>
									<tbody class="" style="width: 100%">
										<tr class="" v-for="type in Object.keys(dat.invoice)">
											<td class="">
												<i class="fas fa-times-circle cursor-pointer"
													@click="removeItem('invoice', 'cashless', type)" />
												<span v-if="!dat.invoice[type].isNew"
													class="text-uppercase pl-2 pr-sm-4 pr-2">{{
														type
													}}</span>
												<input v-if="dat.invoice[type].isNew"
													style="border: none; background-color: transparent" placeholder="NOTE"
													v-model="dat.invoice[type].name"
													@change="checkItemName1('invoice', type)" />
												<i class="fas fa-info-circle cursor-pointer"
													@click="openInfoBox(dat.invoice[type])" />
												<el-input v-if="dat.invoice[type].isDescOpen"
													v-model="dat.invoice[type].desc" :rows="2" type="textarea"
													placeholder="Please input" @focusout="openInfoBox(dat.invoice[type])" />
											</td>

											<td class="">
												<input style="border: none; width: 100%" type="number"
													@change="updateAmount(type)" placeholder="Count"
													v-model="dat.invoice[type].count" />
											</td>
											<td class="">
												<input style="border: none; width: 100%" type="number"
													@change="updateAmount(type)" placeholder="rate"
													v-model="dat.invoice[type].rate" />
											</td>
											<td class="">
												<input style="border: none; width: 100%" placeholder="GST(%)"
													v-model="dat.invoice[type].gst" @change="updateAmount(type)" />
											</td>
											<td class="">
												<input style="border: none; width: 100%" placeholder="Amount" disabled
													v-model="dat.invoice[type].amount" />
											</td>
										</tr>
									</tbody>
									<tbody class="" style="width: 100%">
										<tr class=" font-weight-bold">
											<td class=""></td>
											<td class=""></td>
											<td class=""></td>
											<td class="">Sub Total</td>
											<td class="">
												{{ getSubTotal().toLocaleString('en-IN') }}
											</td>
										</tr>
									</tbody>
									<tbody class="" style="width: 100%">
										<tr class="font-weight-bold">
											<td class=""></td>
											<td class=""></td>
											<td class=""></td>
											<td class="">GST</td>
											<td class="">
												{{ parseFloat(getGst().toFixed(2)).toLocaleString('en-IN', {
													currency: 'INR',
													minimumFractionDigits: 2,
													maximumFractionDigits: 2
												}).endsWith('.00') ?
													parseFloat(getGst().toFixed(2)).toLocaleString('en-IN', {
														currency: 'INR',
														minimumFractionDigits: 2,
														maximumFractionDigits: 2
													}).replace('.00', '') :
													parseFloat(getGst().toFixed(2)).toLocaleString('en-IN', {
														currency: 'INR',
														minimumFractionDigits: 2,
														maximumFractionDigits: 2
													}) }}
											</td>
										</tr>
									</tbody>
									<tbody class="" style="width: 100%">
										<tr class=" font-weight-bold">
											<td class=""></td>
											<td class=""></td>
											<td class=""></td>
											<td class="">Total</td>
											<td class="">
												{{ parseFloat(getInvoiceTotal()).toLocaleString('en-IN', {
													currency: 'INR',
													minimumFractionDigits: 2,
													maximumFractionDigits: 2
												}).endsWith('.00') ?
													parseFloat(getInvoiceTotal()).toLocaleString('en-IN', {
														currency: 'INR',
														minimumFractionDigits: 2,
														maximumFractionDigits: 2
													}).replace('.00', '') :
													parseFloat(getInvoiceTotal()).toLocaleString('en-IN', {
														currency: 'INR',
														minimumFractionDigits: 2,
														maximumFractionDigits: 2
													}) }}
											</td>
										</tr>
									</tbody>
									<tbody class="border-top-0">
										<tr class="">
											<td class="table-secondary font-weight-bold">
												ADD TDS
												<el-switch v-model="dat.tds.isActive" active-color="#13ce66"
													inactive-color="#ccc" :active-value="true" :inactive-value="false"
													class="d-inline" />
											</td>
											<td class="table-secondary font-weight-bold"></td>
											<td class="table-secondary font-weight-bold">PERCENT</td>
											<td class="table-secondary font-weight-bold"></td>
											<td class="table-secondary font-weight-bold">AMOUNT</td>
										</tr>
									</tbody>
									<tbody v-if="dat.tds.isActive" class="" style="width: 100%">
										<tr class="">
											<td class="">
											</td>
											<td class="">
											</td>
											<td class="">
												<input style="border: none; width: 100%" type="number" @change="updateTds()"
													placeholder="Percent" v-model="dat.tds.percent" />
											</td>
											<td class=""></td>
											<td class="">
												{{ dat.tds.amount.toLocaleString('en-IN') }}
											</td>
										</tr>
									</tbody>
									<tbody class="border-top-0">
										<tr class="">
											<td class="table-secondary font-weight-bold">
												EXTRA CHARGES
												<el-button icon="fas fa-plus" class="aml-bg-teal-3 border-0" type="primary"
													size="small" circle @click="addItem('extraCharges', 'cashless')" />
											</td>
											<td class="table-secondary font-weight-bold">COUNT</td>
											<td class="table-secondary font-weight-bold">RATE</td>
											<td class="table-secondary font-weight-bold"></td>
											<td class="table-secondary font-weight-bold">AMOUNT</td>
										</tr>
									</tbody>
									<tbody v-if="dat.extraCharges" class="" style="width: 100%">
										<tr class="" v-for="type in Object.keys(dat.extraCharges)">
											<td class="">
												<i class="fas fa-times-circle cursor-pointer"
													@click="removeItem('extraCharges', 'cashless', type)" />
												<span v-if="!dat.extraCharges[type].isNew"
													class="text-uppercase pl-2 pr-sm-4 pr-2">{{
														type
													}}</span>
												<input v-if="dat.extraCharges[type].isNew"
													style="border: none; background-color: transparent" placeholder="NOTE"
													v-model="dat.extraCharges[type].name"
													@change="checkItemName1('extraCharges', type)" />
												<i class="fas fa-info-circle cursor-pointer"
													@click="openInfoBox(dat.extraCharges[type])" />

												<el-input v-if="dat.extraCharges[type].isDescOpen"
													v-model="dat.extraCharges[type].desc" :rows="2" type="textarea"
													placeholder="Please input"
													@focusout="openInfoBox(dat.extraCharges[type])" />
											</td>

											<td class="">
												<input style="border: none; width: 100%" type="number"
													@change="updateAmount1(type)" placeholder="Count"
													v-model="dat.extraCharges[type].count" />
											</td>
											<td class="">
												<input style="border: none; width: 100%" type="number"
													@change="updateAmount1(type)" placeholder="rate"
													v-model="dat.extraCharges[type].rate" />
											</td>
											<td class=""></td>
											<td class="">
												<input style="border: none; width: 100%" placeholder="Amount" disabled
													@change="updateExtraChargesTotal(type)"
													v-model="dat.extraCharges[type].amount" />
											</td>
										</tr>
									</tbody>
									<tbody class="border-top-0"
										v-if="dat.extraCharges && Object.keys(dat.extraCharges).length > 1">
										<tr>
											<td class="">
											</td>
											<td class=""></td>
											<td clas=""></td>
											<td class="">Total</td>
											<td class="">{{
												getExtraChargesTotal().toLocaleString('en-IN') }}
											</td>
										</tr>
									</tbody>
									<tbody class="" style="width: 100%">
										<tr class=" font-weight-bold">
											<td class=""></td>
											<td class=""></td>
											<td class=""></td>
											<td class="">Payable</td>
											<td class="">
												{{ parseFloat(getPayable()).toLocaleString('en-IN', {
													currency: 'INR',
													minimumFractionDigits: 2,
													maximumFractionDigits: 2
												}).endsWith('.00') ?
													parseFloat(getPayable()).toLocaleString('en-IN', {
														currency: 'INR',
														minimumFractionDigits: 2,
														maximumFractionDigits: 2
													}).replace('.00', '') :
													parseFloat(getPayable()).toLocaleString('en-IN', {
														currency: 'INR',
														minimumFractionDigits: 2,
														maximumFractionDigits: 2
													}) }}
											</td>
										</tr>
									</tbody>
								</table>
							</div>
						</div>
					</div>
				</el-form>
			</span>
			<!-- <template> -->
			<span class="dialog-footer float-right">
				<el-button @click="editDailog = false" v-if="!isLoading.update">Cancel</el-button>
				<el-button class="aml-bg-teal-3 border-0" type="primary" :loading="isLoading.update" @click="updatePaySlip"
					v-if="Object.keys(dat).length > 0">Update</el-button>
			</span>
			<!-- </template> -->
			<!-- </el-dialog> -->
		</span>
	</div>
</template>
<script>
import { Card } from "@/components";
import {
	getBlobFromImageElement,
	copyBlobToClipboard,
} from "copy-image-clipboard";

import * as VueHtml2Image from "html-to-image";
import { copyText } from "vue3-clipboard";
import { toJpeg, toBlob } from "html-to-image";
import axios from "axios";
import {
	ElDivider,
	ElDialog,
	ElForm,
	ElFormItem,
	ElInput,
	ElSelect,
	ElOption,
	ElOptionGroup,
	ElDatePicker,
	ElSwitch,
	ElButton,
	ElMessage,
} from "element-plus";
import moment from "moment";

// import {
// 	getBlobFromImageElement,
// 	copyBlobToClipboard,
// } from "copy-image-clipboard";

export default {
	components: {
		Card,
		ElDivider,
		ElDialog,
		ElForm,
		ElFormItem,
		ElInput,
		ElSelect,
		ElOption,
		ElOptionGroup,
		ElDatePicker,
		ElSwitch,
		ElButton,
		copyText,
		getBlobFromImageElement,
		copyBlobToClipboard,
	},
	inject: ["$baseURL"],
	emits: ["newData", "loading-complete"],
	props: ["event", "details"],
	data() {
		return {
			defaultInfo: {},
			loginUser: {},
			dat: this.details,
			isLoading: { dataDetails: true, update: false },
			invoiceTotal: 0,
			moniesTotal: 0,
			payable: 0,
			editDailog: false,
			extraChargesTotal: 0,
			imageUrl:
				"data:image/png;base64,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",
		};
	},
	watch: {
		details: function (newVal, oldVal) { // watch it
			this.dat = newVal
			this.getMoniesTotal()

		}
	},
	methods: {
		openInfoBox(type) {
			type.isDescOpen = !type.isDescOpen;
		},
		addItem(for_, type, value = { amount: 0, count: 0 }) {
			switch (for_) {
				case "monies":
					this.dat[for_][type][
						"new" + (Object.keys(this.dat[for_][type]).length + 1)
					] = {
						amount: 0,
						count: 0,
						desc: "",
						isDescOpen: false,
						handover: false,
						isNew: true,
						name: "new" + (Object.keys(this.dat[for_][type]).length + 1),
					};
					break;
				case "invoice":
					this.dat[for_]["new" + (Object.keys(this.dat[for_]).length + 1)] = {
						amount: 0,
						count: 0,
						desc: "",
						isDescOpen: false,
						rate: 0,
						gst: 18,
						isNew: true,
						name: "new" + (Object.keys(this.dat[for_]).length + 1),
					};
					break;
				case "extraCharges":
					this.dat[for_]["new" + (Object.keys(this.dat[for_]).length + 1)] = {
						amount: 0,
						count: 0,
						desc: "",
						isDescOpen: false,
						rate: 0,
						isNew: true,
						name: "new" + (Object.keys(this.dat[for_]).length + 1),
					};
					break;
				case "summary":
					this.dat[for_][type] = value;
					break;
			}
		},
		removeItem(for_, type, mode) {
			if (window.confirm("Are You Sure?")) {
				if (for_ === "summary") { return (delete this.dat.summary[type]) };
				if (for_ === "invoice") { return (delete this.dat.invoice[mode] && this.getInvoiceTotal() && this.updateInvoiceCalculations()) };
				if (for_ === "extraCharges") { return (delete this.dat.extraCharges[mode] && this.getExtraChargesTotal() && this.updateExtraChargesTotal()) };
				if (for_ === "info") return delete this.dat.summary.info[type];
				else if (typeof this.dat[for_][type][mode] !== "undefined") { return (delete this.dat[for_][type][mode] && this.getMoniesTotal() && this.updateMoniesTotal()) };
			}
		},
		updateTds() {
			this.dat.tds.amount = this.getSubTotal() * this.dat.tds.percent / 100
		},
		updateAmount(type) {
			// console.log({ type });
			this.dat.invoice[type].amount =
				(this.dat.invoice[type].rate * this.dat.invoice[type].count).toFixed(2);
			this.updateInvoiceCalculations();
		},
		updateInvoiceCalculations() {
			this.updateInvoiceSubTotal();
			this.updateInvoiceTotalGST();
			this.updateInvoiceTotal();
			this.updatePayable();
		},
		updateAmount1(type) {

			this.dat.extraCharges[type].amount =
				(this.dat.extraCharges[type].rate * this.dat.extraCharges[type].count).toFixed(2);
			this.updateExtraChargesTotal()

		},
		updateAmount2() {
			// console.log(this.dat.monies.mdr)
			this.dat.monies.mdr.amount = (
				((this.dat.monies.mdr.cardAmount * this.dat.monies.mdr.rate) / 100) *
				(1 + this.dat.monies.mdr.gst / 100)
			).toFixed(2);
			this.updateMoniesTotal();


		},
		updateMoniesTotal() {
			console.log("in update monies")
			this.dat.monies.moniesSubTotal = this.getMoniesSubTotal();
			this.dat.monies.moniesTotal = this.getMoniesTotal();
			this.updatePayable();
		},
		updateExtraChargesTotal() {
			// console.log("update extra charge total caling", this.getExtraChargesTotal())
			this.dat.extraChargesTotal = this.getExtraChargesTotal();
			this.updatePayable();
		},
		updateInvoiceSubTotal() {
			this.dat.invoiceSubTotal = this.getSubTotal();
			this.updateTds();
		},
		updateInvoiceTotalGST() {
			this.dat.invoiceTotalGST = this.getGst();
		},
		updateInvoiceTotal() {
			this.dat.invoiceTotal = this.getInvoiceTotal();
		},
		updatePayable() {
			console.log("dat", this.dat)
			this.dat.payable = this.getPayable();
		},
		updatePaySlip() {
			this.isLoading.update = true;
			let data = this.dat;

			console.log({ data });
			var isFormValid = true;
			Object.keys(data.invoice).map((key) => {
				if (data.invoice[key].amount <= 0) {
					isFormValid = false;
				}
			});
			Object.keys(data.extraCharges).map((key) => {
				if (data.extraCharges[key].amount <= 0) {
					isFormValid = false;
				}
			});
			Object.keys(data.monies).map((key) => {
				if (key !== "mdr") {
					if (data.monies[key].amount <= 0) {
						isFormValid = false;
					}
				} else {
					if (data.monies[key].amount < 0) {
						isFormValid = false;
					}
				}
			});

			Object.keys(data.invoice).map((key) => {
				if (data.invoice[key].amount <= 0) {
					isFormValid = false;
				}
				// if (key !== "invoiceSubTotal" && key !== "invoiceTotal" && key !== "invoiceTotalGST") {
				// 	if (data.monies[key].amount <= 0) {
				// 		isFormValid = false;
				// 	}
				// } else {
				// 	if (data.monies[key].amount < 0) {
				// 		isFormValid = false;
				// 	}
				// }
			});

			if (isFormValid) {
				axios
					.post(this.$baseURL + "/Event/EventDataSave/", data, {
						headers: {
							Authorization: `Bearer ${localStorage.getItem("xToken")}`,
						},
					})
					.then((response) => {
						if (response.data.success) {
							this.dat = {};
							this.$emit("newData", response.data.log);
							this.$emit("dataSelected", response.data.log);
							this.editDailog = false;
						}

						this.isLoading.update = false;
					})
					.catch((error) => {
						ElMessage({
							showClose: true,
							dangerouslyUseHTMLString: true,
							message: "<b>Something went wrong</b><br>Please try again.",
							type: "danger",
							grouping: true,
							duration: 5000,
						});
						console.log("err:", error);
						this.isLoading.update = false;
					});
			} else {
				this.isLoading.update = false;
				alert("Amount can't be zero");
			}
		},
		getExtraChargesTotal() {
			if (!this.dat.extraCharges) {
				return 0;
			}
			const invoiceArray = Object.values(this.dat.extraCharges);
			return invoiceArray.reduce((acc, currentObject) => {
				if (currentObject.hasOwnProperty("amount")) {
					return acc + +currentObject["amount"];
				} else {
					return acc;
				}

			}, 0);
		},
		getMoniesSubTotal() {
			let total = 0;
			Object.keys(this.dat.monies).map((obj) => {
				Object.keys(this.dat.monies[obj]).map((obj1) => {

					if (this.dat.monies[obj][obj1].handover == false) {
						total = total + parseFloat(this.dat.monies[obj][obj1].amount);
					}
				});
			});
			this.moniesSubTotal = total;
			return this.moniesSubTotal;
		},
		getMoniesTotal() {
			this.moniesTotal = this.getMoniesSubTotal() - parseFloat(this.dat.monies.mdr.amount);
			return this.moniesTotal;
		},
		getSubTotal() {
			const invoiceArray = Object.values(this.dat.invoice);
			return invoiceArray.reduce((acc, currentObject) => {
				if (currentObject.hasOwnProperty("amount")) {
					return acc + +currentObject["amount"];
				} else {
					return acc;
				}
			}, 0);
		},
		getGst() {
			const invoiceArray = Object.values(this.dat.invoice);
			return invoiceArray.reduce((acc, currentObject) => {
				if (
					currentObject.hasOwnProperty("amount") &&
					currentObject.hasOwnProperty("gst")
				) {
					return acc + (+currentObject["amount"] * +currentObject["gst"]) / 100;
				} else {
					return acc;
				}
			}, 0);
		},
		getInvoiceTotal() {
			this.invoiceTotal = this.getGst() + this.getSubTotal();
			return this.invoiceTotal.toFixed(2);
		},
		getPayable() {
			console.log({ moniesTotal: this.moniesTotal, invoiceTotal: this.invoiceTotal, getExtraChargesTotal: this.getExtraChargesTotal() })
			this.payable =
				this.moniesTotal - this.invoiceTotal - this.getExtraChargesTotal() + (this.dat.tds.isActive ? this.dat.tds.amount : 0);
			console.log('payable', this.payable)
			return this.payable;
		},
		getFormattedDate(dateString) {
			const date = new Date(dateString);
			date.setUTCHours(0, 0, 0, 0); // Set the time to midnight in UTC
			const year = date.getUTCFullYear();
			const monthNames = [
				"Jan", "Feb", "Mar", "Apr", "May", "Jun",
				"Jul", "Aug", "Sep", "Oct", "Nov", "Dec"
			];
			const monthName = monthNames[date.getUTCMonth()];
			const day = date.getUTCDate();
			return `${day} ${monthName} ${year}`;
		},
		async downloadImageAndShare() {
			const node = document.getElementById("HtmlContent");
			const imageUrl_ = await VueHtml2Image.toPng(node);
			const startDate = this.getFormattedDate(this.details.info.minTxnAt);
			const textMessage = `${this.event.name} (${this.event.id}), ${this.event.locationCity.charAt(0).toUpperCase() + this.event.locationCity.slice(1)}, ${startDate} \n${this.dat.payable > 0 ? "Payable:" : "Recievable:"} *${Math.abs(this.dat.payable).toLocaleString("en-IN")}* `
			copyText(textMessage, undefined, (error, event) => { });
			ElMessage({
				offset: 700,
				showClose: true,
				dangerouslyUseHTMLString: true,
				message: "<b>Payslip downloaded and amount copied.",
				type: 'success',
				grouping: true,
				duration: 10000,
			});
			var a = document.createElement("a"); //Create <a>
			a.href = imageUrl_; //Image Base64 Goes here
			a.download = `AtomX Payslip, ${this.event.name}`; //File name Here
			a.click(); //Downloaded file
		},
		async shareOnWhatsApp() {
			const node = document.getElementById("HtmlContent");
			// try {
			const startDate = this.getFormattedDate(this.details.info.minTxnAt);
			const imageUrl_ = await VueHtml2Image.toPng(node);
			const textMessage = `${this.event.name} (${this.event.id}),
		${this.event.locationCity.charAt(0).toUpperCase() +
				this.event.locationCity.slice(1)}, ${startDate} %0a${this.dat.payable > 0 ? "Payable:" : "Recievable:"} *${Math.abs(this.dat.payable).toLocaleString("en-IN")}* `
			this.imageUrl = imageUrl_;
			// this.shareImageOnWhatsApp(imageUrl);
			// } catch (error) {
			// 	console.error("Error converting to image:", error);
			// }
			setTimeout(() => {
				const imageElement = document.getElementById("img1");

				getBlobFromImageElement(imageElement)
					.then((blob) => {
						return copyBlobToClipboard(blob);
					})
					.then(() => {
						console.log("Blob Copied");
						ElMessage({
							offset: 700,
							showClose: true,
							dangerouslyUseHTMLString: true,
							message: "<b>Payslip copied! paste it to share</b>",
							type: 'success',
							grouping: true,
							duration: 10000,
						});
					})
					.catch((e) => {
						console.log("Error: ", e.message);
					});
			}, 100);
			setTimeout(() => {
				const shareUrl = `whatsapp://send?text=${textMessage} `;
				window.location.href = shareUrl;
			}, 200);
		},
		setDefault(key = "all") {
			if (key !== "all")
				this[key] = JSON.parse(JSON.stringify(this.defaultInfo[key]));
			else {
				for (const [key, value] of Object.entries(this.defaultInfo)) {
					this[key] = JSON.parse(JSON.stringify(value));
				}
			}
		},
		getInfoName() {
			if (this.details.info.days.length > 0) {
				switch (this.details.info.days.length) {
					case 1:
						return this.details.info.days[0].name;
						break;
					case 2:
						return (
							this.details.info.days[1].name +
							" to " +
							this.details.info.days[0].name
						);
						break;
				}
			} else if (this.details.info.dates.length > 0) {
				return (
					this.details.info.dates[0] +
					" to " +
					this.details.info.dates[1]
				);
			} else {
				return "Full Event";
			}
		},
		displaydt(dt) {
			return moment(dt).isValid()
				? moment(dt).local().format("YYYY-MM-DD HH:mm:ss")
				: "";
		},
		summaryHas(type) {
			switch (type) {
				case "cashless":
					return (
						this.details &&
						this.details.summary &&
						this.details.summary &&
						(this.details.summary.topup ||
							this.details.summary.sale ||
							this.details.summary.return ||
							this.details.summary.activations)
					);
					break;
				// case "pos":
				// 	return (
				// 		this.details &&
				// 		this.details.summary &&
				// 		this.details.summary &&
				// 		this.details.summary.no_nfc_sale
				// 	);
				// 	break;
				default:
					return false;
					break;
			}
		},
		moniesHas(type) {
			switch (type) {
				case "cashless":
					return (
						this.details &&
						this.details.monies &&
						this.details.monies.cashless);
					break;
				case "pos":
					return (
						this.details &&
						this.details.monies.pos
					);
					break;
				case "mdr":
					return (
						this.details &&
						this.details.monies.mdr &&
						this.details.monies.mdr.amount > 0
					);
					break;
				default:
					return false;
					break;
			}
		},
		checkItemName1(for_, type) {
			if (this.details[for_][type].name === "")
				return alert("Name incorrect for item");
			if (this.details[for_][type].name.includes(" ")) {
				this.details[for_][type].name = this.details[for_][type].name.replace(/ /g, "");
				alert("Spaces Removed");
			}
			// debugger;
			if (
				typeof this.details[for_][type][this.details[for_][type].name] !==
				"undefined" &&
				this.details[for_][type].name !== type
			) {
				return alert("Name exists, please change");
			} else {
				// let mode_ = this.dat[for_][type][mode];
				if (this.details[for_][type].name !== type) {
					let name_ = this.details[for_][type].name;
					this.details[for_][name_] = this.details[for_][type];
					delete this.details[for_][type];
					delete this.details[for_][name_].isNew;
					delete this.details[for_][name_].name;
				} else {
					delete this.details[for_][type].isNew;
					delete this.details[for_][type].name;
				}
			}
		},
		checkItemName(for_, type, mode) {
			if (this.details[for_][type][mode].name === "")
				return alert("Name incorrect for item");
			if (this.details[for_][type][mode].name.includes(" ")) {
				this.details[for_][type][mode].name = this.details[for_][type][
					mode
				].name.replace(/ /g, "");
				alert("Spaces Removed");
			}
			// debugger;
			if (
				typeof this.details[for_][type][
				this.details[for_][type][mode].name
				] !== "undefined" &&
				this.details[for_][type][mode].name !== mode
			) {
				return alert("Name exists, please change");
			} else {
				// let mode_ = this.details[for_][type][mode];
				if (this.details[for_][type][mode].name !== mode) {
					let name_ = this.details[for_][type][mode].name;
					this.details[for_][type][name_] = this.details[for_][type][
						mode
					];
					delete this.details[for_][type][mode];
					delete this.details[for_][type][name_].isNew;
					delete this.details[for_][type][name_].name;
				}
			}

			delete this.details[for_][type][mode].isNew;
			delete this.details[for_][type][mode].name;
		},
	},
	mounted() {
		this.dat = this.details;
		// setTimeout(this.loadDetails, 500);
		let u = JSON.parse(localStorage.getItem("user"));
		this.loginUser = u;
		if (!u || Object.keys(u).length === 0 && u.constructor === Object)
			return this.$router.push("/login");
		// this.loadDetails();
	},
};
</script>
